import React from 'react'
import { connect } from 'react-redux'
import Zestawienie from '../../components/Zestawienie/Zestawienie'
import ZestawienieHeader from '../../components/Zestawienie/ZestawienieHeader'
import ZestawienieName from '../../components/Zestawienie/ZestawienieName'
import { formulyPozycjePozabilansowe } from '../../lib/formulas'
import zaokragl from '../../lib/mathUtils'
import { czyKwotyWTysiacach } from '../../lib/structureChecker'
import * as actions from '../../store/actions'
import BilansStyle from '../../styles/BilansStyle'

export class PozycjePozabilansowe extends React.Component {
  isValueInThirdColumn = () => {
    return this.props.section.Dane.Pozycje.some(i => i.KwotaB1 !== 0)
  }

  state = { isThirdColumn: this.isValueInThirdColumn() }

  setIsThirdColumn = v => {
    this.setState({ isThirdColumn: v })
  }

  sumValues = (value, changedIndex, name, parts) => {
    let partsSum = 0
    parts.forEach(x => {
      partsSum = zaokragl(
        partsSum +
          (x === changedIndex
            ? value
            : this.props.section.Dane.Pozycje[x][name]),
      )
    })
    return partsSum
  }

  aktualizujSumy = (value, index, name) => {
    if (!value) value = 0
    this.props.onSetSectionDataArray(value, index, name)
    formulyPozycjePozabilansowe.forEach(x => {
      const suma = this.sumValues(value, index, name, x.polaSkladowe)
      this.props.onSetSectionDataArray(suma, x.poleSumy, name)
    })
  }

  render() {
    return (
      <BilansStyle>
        <ZestawienieName name="POZYCJE POZABILANSOWE" hideButtons />
        <ZestawienieHeader
          isThirdColumn={this.state.isThirdColumn}
          onCheck={e => this.setIsThirdColumn(e.target.checked)}
        />
        <div className="container">
          <Zestawienie
            onSetSectionDataArray={(value, index, name) =>
              this.aktualizujSumy(value, index, name)
            }
            dane={this.props.section.Dane.Pozycje}
            czyKwotyWTysiacach={this.props.czyKwotyWTysiacach}
            isThirdColumn={this.state.isThirdColumn}
          />
        </div>
      </BilansStyle>
    )
  }
}

const mapStateToProps = state => ({
  czyKwotyWTysiacach: czyKwotyWTysiacach(state.sprawozdanie.header),
})

const mapDispatchToProps = dispatch => ({
  onSetSectionDataArray: (value, index, name) => {
    dispatch(actions.setSectionDataArray(value, index, 0, name))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PozycjePozabilansowe)
